/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0)
    return 1;
return 5;
}

export default ["nl",[["a.m.","p.m."]],u,[["Z","M","D","W","D","V","Z"],["zo","ma","di","wo","do","vr","za"],["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],["zo","ma","di","wo","do","vr","za"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"]],u,[["v.C.","n.C."],["v.Chr.","n.Chr."],["voor Christus","na Christus"]],1,[6,0],["dd-MM-y","d MMM y","d MMMM y","EEEE d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","Â¤Â #,##0.00;Â¤Â -#,##0.00","#E0"],"EUR","â¬","Euro",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"CAD":["C$","$"],"FJD":["FJ$","$"],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"RUR":[u,"Ñ."],"SBD":["SI$","$"],"THB":["à¸¿"],"TWD":["NT$"],"USD":["US$","$"],"XCG":["Cg.","Cg"],"XPF":[],"XXX":[]},"ltr", plural];
